import type { MediaImage } from "@/lib/media";
import { cn } from "@/lib/utils";

export function Picture({
  image,
  alt,
  sizes,
  className,
  imgClassName,
  loading = "lazy",
  decoding = "async",
  fetchPriority,
  width,
  height,
}: {
  image: MediaImage;
  alt: string;
  sizes: string;
  className?: string;
  imgClassName?: string;
  loading?: "lazy" | "eager";
  decoding?: "async" | "sync" | "auto";
  fetchPriority?: "high" | "low" | "auto";
  width?: number;
  height?: number;
}) {
  return (
    <picture className={className}>
      {image.srcSetAvif ? <source type="image/avif" srcSet={image.srcSetAvif} sizes={sizes} /> : null}
      {image.srcSetWebp ? <source type="image/webp" srcSet={image.srcSetWebp} sizes={sizes} /> : null}
      <img
        src={image.src}
        alt={alt}
        width={width ?? image.width}
        height={height ?? image.height}
        sizes={sizes}
        loading={loading}
        decoding={decoding}
        fetchPriority={fetchPriority}
        className={cn(imgClassName)}
      />
    </picture>
  );
}
